import integrationsService from 'services/api/integrations.service';
import { toast } from 'react-toastify';

export function validateCertFile(file: File | null): string | null {
    if (!file) {
        return 'Choose a certificate file first.';
    }
    if (file.size === 0) {
        return 'This file is empty (0 bytes). Do not upload a failed download — use Download reference certificate.';
    }
    const name = file.name.toLowerCase();
    if (!/\.(cer|crt|pem|p12|pfx)$/.test(name)) {
        return 'Use a .cer, .crt, .pem, .p12, or .pfx file.';
    }
    return null;
}

export async function downloadReferenceCertificate(partnerCode: string): Promise<void> {
    try {
        const res = await integrationsService.downloadReferenceCertificate(partnerCode);
        const blob = res.data as Blob;
        if (!blob || blob.size === 0) {
            toast.error('Downloaded file is empty. Check openas2/certs/partners/ on the server.', {
                autoClose: 8000,
            });
            return;
        }
        const disposition = res.headers['content-disposition'] as string | undefined;
        let filename = `${partnerCode}.cer`;
        const match = disposition?.match(/filename="?([^"]+)"?/);
        if (match?.[1]) {
            filename = match[1];
        }
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
        toast.success(`Downloaded ${filename} (${blob.size} bytes)`, { autoClose: 5000 });
    } catch {
        toast.error(
            `Could not download reference certificate for ${partnerCode}. Ensure the file exists under openas2/certs/partners/.`,
            { autoClose: 8000 }
        );
    }
}
